export default __webpack_public_path__ + "static/char-t-20-en-b379af0f5878f9e78c7fd9aee2492ff1.png";